import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from "rxjs/operators";
import { ActivatedRoute } from '@angular/router';
import { Subscription } from "rxjs";
import { MatSnackBar } from '@angular/material/snack-bar';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';
import { AngularFirestore } from '@angular/fire/firestore';

interface empresaCliente {
  nombre: string,
  resumen: string,
  descripcion: string,
  sitioWeb: string,
  enlaceLinkedin: string,
  foto: string,
  cantCursos: number,
  cantUsuarios: number,
  cantCupos: number,
  creador: string,
  fechaCreacion: Date,
  ultimaEdicion: Date,
  ultimoEditor: string,
  publicado: string,
}

@Component({
  selector: 'form-empresa-cliente',
  templateUrl: './form-empresa-cliente.component.html',
  styleUrls: ['./form-empresa-cliente.component.css']
})
export class FormEmpresaClienteComponent implements OnInit {


  constructor(
    private shared: RoutingVariablesService,
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private storage: AngularFireStorage,
    private _snackBar: MatSnackBar,
  ) { }

  //spinner
  loaded = 0

  // infomacion del adminstrador:
  usuario: any;
  userToken: string;
  subscripcionUsuario: Subscription
  subscripcionToken: Subscription

  // Si vamos a editar entonces debe tener un id en la ruta
  id = this.route.snapshot.paramMap.get('id');

  empresa: empresaCliente = {
    nombre: '',
    resumen: '',
    descripcion: '',
    sitioWeb: '',
    enlaceLinkedin: '',
    foto: '',
    cantCursos: 0,
    cantUsuarios: 0,
    cantCupos: 0,
    creador: '',
    fechaCreacion: new Date,
    ultimaEdicion: new Date,
    ultimoEditor: '',
    publicado: '',
  }

  // auxiliares para cargar fotos
  downloadURL: any;
  fire: any;

  // auxiliares para borrar empresa
  confirmar: number = 0;
  textoConfirmacion: string;

  // FLAG
  editar = 0;

  ngOnInit(): void {
    this.subscripcionUsuario = this.shared.getUsuario().subscribe(usuario => {
      this.usuario = usuario.usuario; 
    })
    this.subscripcionToken = this.shared.getToken().subscribe(token => {
      this.userToken = token.token; 
    })
    this.verificarEdicionOCreacion();
  }

  verificarEdicionOCreacion() {
    if (this.id == null) {
      this.inicializarCrearEmpresa();
    } else {
      this.inicializarEditarEmpresa();
    }
  }

  // INICIALIZACION DE CREAR EMPRESA

  inicializarCrearEmpresa() {
    this.editar = 0;
    this.loaded = 1;
  }

  /// INICIALIZACION DE EDICION DE EMPRESA //

  inicializarEditarEmpresa() {
    this.editar = 1
    this.cargarEmpresa();
  }

  cargarEmpresa() {
    this.afs.collection('empresasCliente').doc(this.id).ref.get().then(doc => {
      const empresa = doc.data();
      this.empresa = {
        nombre: empresa['nombre'],
        resumen: empresa['resumen'],
        descripcion: empresa['descripcion'],
        sitioWeb: empresa['sitioWeb'],
        enlaceLinkedin: empresa['enlaceLinkedin'],
        foto: empresa['foto'],
        cantCursos: empresa['cantCursos'],
        cantUsuarios: empresa['cantUsuarios'],
        cantCupos: empresa['cantCupos'],
        creador: empresa['creador'],
        fechaCreacion: empresa['fechaCreacion'],
        ultimaEdicion: empresa['ultimaEdicion'],
        ultimoEditor: empresa['ultimoEditor'],
        publicado: empresa['publicado']
      }
      this.loaded = 1;
    }).catch(error => {
      console.log(error)
      alert('No se ha podido guardar la empresa')
    });
  }

  /// FUNCIONALIDADES ///////////////////////////////

  cargarFoto(event, campo) {
    var n = Date.now();
    const file = event.target.files[0];
    const filePath = `EmpresasCliente/${n}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`EmpresasCliente/${n}`, file);
    task
      .snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL(); //Donde se usa este download URL?
          this.downloadURL.subscribe(url => {
            if (url) { this.fire = url; }  //'fire' se usa?
            console.log(this.fire)
            if (campo == "foto") {
              this.empresa.foto = url;
            }
          });
        })
      )
      .subscribe(url => {
        if (url) {
          console.log(url);
        }
      });
  }

  guardarEmpresa() {
    /// Empresa nuevo creado
    if (this.editar == 0) {
      this.id = this.empresa.nombre.split(' ').join('-');
      this.empresa.creador = this.usuario.uid;
      
      this.empresa.fechaCreacion = new Date();
    }
    this.empresa.ultimaEdicion = new Date();
    this.empresa.ultimoEditor = this.usuario.uid;

    this.afs.collection('empresasCliente').doc(this.id).set(this.empresa, { merge: true }).then(() => {
      this.operacionExitosa();
    }).catch(error => {
      console.log(error)
    })
    
  }

  eliminarEmpresa() {
      this.afs.collection('empresasCliente').doc(this.id).delete().catch(error => console.log(error));
      this.operacionExitosa();   
  }

  operacionExitosa(message: string = 'Operación exitosa', action: string = '') {
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['gray-snackbar'],
    });
  }
}
